import PeopleIcon from "@mui/icons-material/People";
import { Typography } from "@mui/material";
import { dateValueGetter, Toolbar } from "common";
import I18n from "i18n-js";
import { useMemo } from "react";
import DataCard from "../../../components/DataCard/DataCard";
import {
  CardSettings,
  DataCardColumnSettings,
} from "../../../components/DataCard/useDataCard";
import LocationForm from "./LocationForm";
import useLocationList from "./useLocationList";
export default function LocationList() {
  const { grid, locationLimit, locationCount, canAddLocation } =
    useLocationList();
  let columnSettings: DataCardColumnSettings = {
    date: { valueFormatter: dateValueGetter },
  };

  const cardSettings: CardSettings = useMemo(() => {
    return {
      header: {
        titleField: "address",
      },
    };
  }, []);

  return (
    <>
      <DataCard
        headerTitle={
          <Toolbar sx={{ gap: 2 }}>
            <PeopleIcon />
            <Typography variant="h5">{I18n.t("Location.title")}</Typography>
          </Toolbar>
        }
        {...grid}
        columns={[
          { field: "address", flex: 1 },
          { field: "address2", flex: 1 },
          { field: "county", flex: 1 },
          { field: "zip" },
        ]}
        cardSettings={cardSettings}
        renderModalForm={props => <LocationForm {...props} />}
        columnSettings={columnSettings}
        headerItems={["search", "refresh"]}
        // canCreate={canAddLocation}
        canCreate
        canDelete
        canEdit
      />
    </>
  );
}
